import { Link,useLocation } from 'react-router-dom';
import guides from '../../lib/calculatorGuides.json';
import routes from '../../lib/siteRoutes.json';

interface Guide { intro: string; sections: { heading: string; paragraphs: string[] }[]; example: { heading: string; text: string }; related: string[]; sources?: { label: string; url: string }[] }

/** The same editorial content is included in the initial HTML by prerender.mjs. */
export default function CalculatorGuide() {
  const path = useLocation().pathname.replace(/\/+$/, '') || '/';
  const guide = (guides as Record<string, Guide>)[path];
  if (!guide || path === '/embed-calculators') return null;
  const page = routes.find(route => route.path === path);
  return <article className="w-full min-w-0 max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-10 space-y-6 leading-7 break-words text-gray-700 dark:text-gray-300" aria-label="Calculator explanation">
    <nav aria-label="Breadcrumb" className="text-sm"><Link className="underline" to="/">Calculato</Link> <span aria-hidden="true"> / </span>{page?.heading}</nav>
    <h2 className="text-2xl font-bold text-gray-900 dark:text-white">How to use this calculator</h2>
    <p>{guide.intro}</p>
    {guide.sections.map(section => <section key={section.heading} className="space-y-3">
      <h3 className="text-xl font-semibold text-gray-900 dark:text-white">{section.heading}</h3>
      {section.paragraphs.map(paragraph => <p key={paragraph}>{paragraph}</p>)}
    </section>)}
    <section className="rounded-xl bg-blue-50 dark:bg-gray-800 p-5 space-y-3"><h3 className="text-xl font-semibold">{guide.example.heading}</h3><p>{guide.example.text}</p></section>
    {guide.sources && <section><h3 className="font-semibold mb-3">Sources and further reading</h3><ul>{guide.sources.map(source => <li key={source.url}><a className="underline" href={source.url}>{source.label}</a></li>)}</ul></section>}
    <nav aria-label="Related calculators"><h3 className="font-semibold mb-3">Related calculators</h3><ul className="flex flex-wrap gap-4">{guide.related.map(related => {
      const destination = routes.find(route => route.path === related);
      return destination ? <li key={related}><Link className="underline" to={related}>{destination.heading}</Link></li> : null;
    })}</ul></nav>
  </article>;
}
